import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row mt-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-11" }, null, -1)
const _hoisted_3 = { class: "col-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isOpen) = $event)),
    width: "70%",
    title: _ctx.titleDisplay,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        modelValue: _ctx.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        class: "mb-3",
        style: {"width":"20rem"},
        placeholder: "Tìm toa xe theo mã hoặc tên",
        onInput: _ctx.search
      }, null, 8, ["modelValue", "onInput"]),
      _createVNode(_component_el_table, {
        style: {"width":"100%"},
        "max-height": "500",
        "empty-text": "Đang hiển thị danh sách toa xe",
        "row-class-name": "table-row",
        size: "small",
        "cell-style": {padding: '0', height: '15px'},
        border: true,
        data: _ctx.toaXeItems,
        onRowClick: _ctx.onRowClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { width: "55" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.selectedToaXeIdArr[scope.$index],
                "onUpdate:modelValue": ($event: any) => ((_ctx.selectedToaXeIdArr[scope.$index]) = $event),
                readonly: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "STT",
            width: "60"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.indexCal(scope.$index, _ctx.currentPage, 10)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "ID",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.id), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Tên" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ten_toa_xe), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Mã Toa xe" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ma_toa_xe), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Chủng loại" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.chung_loai_toa_xe?.ky_hieu
							? scope.row.chung_loai_toa_xe?.ky_hieu
							: '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Ghi chú" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ghi_chu ? scope.row.ghi_chu : '-'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onRowClick"]),
      (_ctx.toaXeItems.length > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": 20,
            total: _ctx.totalItems,
            onChangePage: _cache[1] || (_cache[1] = (value) => _ctx.currentPage = value)
          }, null, 8, ["page", "total"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ButtonCustom, {
            "button-type": _ctx.ButtonsType.SAVE,
            "color-type": _ctx.ButtonTypeColors.SUCCESS,
            onClick: _ctx.submit
          }, null, 8, ["button-type", "color-type", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]))
}